import React, { Component } from "react";
import UserUnitView from "presentational/common/userUnit/UserUnitView";
import CommonMoreRequestButton from "presentational/common/CommonMoreRequestButton";
import PropTypes from "prop-types";

class FollowUserListView extends Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired,
    onRequestBtnClick: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired
  };

  render() {
    const { list, isLoading, isEnd, onRequestBtnClick, onClick } = this.props;

    const followList = list.map((oneObj, index) => (
      <UserUnitView
        key={index}
        name={oneObj.username}
        image={oneObj.image}
        location={oneObj.location}
        gender={oneObj.gender}
        onClick={onClick}
      />
    ));

    return (
      <div>
        {followList}
        {!isEnd && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CommonMoreRequestButton
              onClick={onRequestBtnClick}
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    );
  }
}

export default FollowUserListView;
